import React from 'react';
import NextJsProject from '../Projects/NextJsProject/NextJsProject';
import PopularProjects from '../Projects/PopularProjects/PopularProjects';
import TeamProjects from '../Projects/TeamProjects/TeamProjects';

import ContactForm from '../Shared/ContactForm/ContactForm';

import HomePart from './HomePart/HomePart';

const Home = () => {
    return (
        <div >
            <HomePart></HomePart>
            <h1 className="text-center text-light"><i><b>Team Projects</b></i></h1>
            <TeamProjects/>
            <h1 className="text-center text-light"><i><b>NextJS project</b></i></h1>
            <NextJsProject/>
            <h1 className="text-center text-light"><i><b>MERN Stack Projects</b></i></h1>
            <PopularProjects></PopularProjects>
            <ContactForm></ContactForm>
          
        </div>
    );
};

export default Home;